const id = {
  menuInboundCall: "CS Call Center",
  menuInboundCallHistory: "Call History",
  menuInboundCallHistorySubtitle:
    "Kamu bisa melihat riwayat call yang sudah dilakukan",
  callAssigned: "Telepon Ditugaskan",
  callQueue: "Telepon Antri",
  searchContactLabel: "Cari kontak atau keyword",
  callDuration: "Durasi Telepon",
  callNotes: "Catatan:",
  voiceCall: "Panggilan Suara",
  callFollowupDuration: "Panggilan ditutup dengan durasi ",
  callFollowup: "Kirim pesan follow up",
  callConnected: "Tersambung",
  callIncomingText: "Panggilan masuk dari ",
  callIncomingMissed: "Panggilan tidak terjawab ",
  callIncomingAssign: "Ditugaskan ke cs",
  callVoicebotText: "Ditangani Voice Bot ",
  callQueueText: " antri disambungkan ke agen",
  callAssignedText: " ditugaskan ke cs ",
  inboundCallIncomingCallLabel: "Panggilan Masuk",
  inboundCallAnswerCallNotification: "Jawab",
  inboundCallRejectCallNotification: "Tolak",
  inboundCallANSStatus: "Sedang Dalam Panggilan",
  inboundCallRINStatus: "Panggilan Masuk",
  inboundCallCMPStatus: "Panggilan Selesai",
  inboundCallRJCStatus: "Panggilan Ditolak",
  inboundCallNOAStatus: "Panggilan Tidak Terjawab",
  inboundCallErrorMessage: "Terjadi kesalahan, coba lagi",
  noOpenChatTitle: "Chat kosong",
  noOpenChatSubtitle: "Tidak ada chat yang di buka",
  downloadCallHistory: "Unduh Riwayat Panggilan",
  tabCallHistory: "Riwayat panggilan",
  tabCallExportHistory: "Permintaan export riwayat",
  labelSearchContact: "Cari Nomor Telepon",
  labelSearchUser: "Pilih User",
  labelSearchDate: "Pilih Waktu Panggilan",
  mediaTypeCallWAP: "Whatsapp Call",
  headerNameAndPhone: "Nama & Nomor Kontak",
  headerTicketId: "Id Tiket",
  headerCSAgent: "Agen CS",
  headerChannel: "Channel",
  headerResolveTime: "Waktu Resolusi",
  headerClosedBy: "Ditutup Oleh",
  headerAction: "Aksi",
  historyRequestType: "Tipe Riwayat",
  historyCallType: "Riwayat panggilan",
  recordCallType: "Rekaman panggilan",
  validationDateRequiredMessage: "Tanggal harus diisi",
  requestHistoryStatusDone: "Selesai",
  requestHistoryStatusInProgress: "Sedang diproses",
  requestHistoryStatusFailed: "Gagal",
  tooltipDownloadReport: "Unduh riwayat",
  tooltipCannotDownloadReport: "Permintaan riwayat sedang diproses",
  headerReportFilename: "Nama File",
  headerReportUser: "User",
  headerReportType: "Tipe Riwayat",
  headerReportCreatedAt: "Tanggal Dibuat",
  headerReportStatus: "Status",
  errorOpeningRecord: "Terjadi kesalahan ketika membuka rekaman",
  errorAnswerCall: "Terjadi kesalahan ketika menjawab panggilan",
  callButtonMuteDisabled:
    "Panggilan sedang dipegang, anda tidak dapat menyalakan mikrofon",
  errorHoldCall: "Terjadi kesalahan ketika melepaskan panggilan",
  ringingStatusDuration: "Queued for {0}",
  answeredStatusDuration: "In call for {0}",
  closeCallRoomTitle: "Tutup Panggilan",
  closeCallRoomNote: "Ruang panggilan akan di pindah ke Riwayat Panggilan",
  inboundCallCloseRoomSuccess: "Ruang panggilan berhasil ditutup",
  chatroomChatDetailCallStarted: "Panggilan dimulai",
  chatroomChatDetailRoomId: "Room ID",
  inboundCallUpdateRoomSuccess: "Ruang panggilan berhasil diubah",
  inboundCallUpdateRoomFailed: "Ruang panggilan gagal diubah",
  inboundCallChatFailed: "Gagal mengirim pesan",
  inboundCallActivateMic: "Akses Mikrofon belum aktif",
  inboundCallActivateMicSubtitle:
    "Nyalakan izin mikrofon untuk menerima panggilan",
  inboundCallActivateMicDialogTitle: "Akses Mikrofon",
  inboundCallActivateMicDialogContent:
    "Untuk menjawab panggilan, pastikan izin mikrofon sudah aktif. Klik ikon {0} di sebelah Kokatto URL, lalu klik opsi mikrofon untuk mengaktifkan.",
  inboundCallMicPermissionErrorMessage:
    "Aktifikan {0} pada pengaturan situs terlebih dahulu.",
  inboundCallMicPermission: "izin mikrofon",
  inboundCallListEmptyState: "Belum ada panggilan aktif",
  inboundCallActiveCallLimitationError:
    "Anda hanya dapat memiliki 1 panggilan aktif pada saat yang bersamaan.",
  inboundCallPickupByAnotherAgent: "Panggilan sudah dijawab oleh agen lain.",
  roomTypeWhatsapp: "Whatsapp Call",
  roomTypePhone: "Call Center",
  roomTypeAll: "Semua",
  retryButton: "Coba Lagi",
  callButtonTransfer: "Transfer",
  successTransferCall: "Panggilan berhasil ditransfer",
  errorTransferCall: "Gagal menransfer panggilan",
  callDetail: "Detail Panggilan",
  inboundCallRoleNotAllowedAnswer:
    "Role Anda tidak memiliki akses untuk menjawab panggilan",
  inboundCallRoleNotAllowedReject:
    "Role Anda tidak memiliki akses untuk menolak panggilan",
  menuCallPerformanceTabReport: "Call Center",
  callPerformanceReport: "Call Performance",
  callAnalyticsReport: "Analytics",
};

const en = {
  menuInboundCall: "CS Call",
  menuInboundCallHistory: "CS Call History",
  menuInboundCallHistorySubtitle:
    "You can view the history of calls that have been made.",
  callAssigned: "Call Assigned",
  callQueue: "Call Queue",
  searchContactLabel: "Search Contact and Keyword",
  callDuration: "Call Duration",
  callNotes: "Notes:",
  voiceCall: "Voice Call",
  callFollowupDuration: "Call Ended duration ",
  callFollowup: "Send follow up message",
  callConnected: "Connected",
  callIncomingText: "Incoming Call from ",
  callIncomingMissed: "Missed call ",
  callIncomingAssign: "assigned to cs",
  callVoicebotText: "Voice Bot handle ",
  callQueueText: " queue connect to agent",
  callAssignedText: " assigned to cs ",
  inboundCallIncomingCallLabel: "Incoming Call",
  inboundCallAnswerCallNotification: "Answer",
  inboundCallRejectCallNotification: "Reject",
  inboundCallANSStatus: "On a call",
  inboundCallRINStatus: "Ringing",
  inboundCallCMPStatus: "Call ended",
  inboundCallRJCStatus: "Call rejected",
  inboundCallNOAStatus: "Missed call",
  inboundCallErrorMessage: "An error occurred, try again",
  noOpenChatTitle: "Empty chat",
  noOpenChatSubtitle: "There is no open chat",
  downloadCallHistory: "Download Call History",
  tabCallHistory: "Call history",
  tabCallExportHistory: "Request export history",
  labelSearchContact: "Search Phone Number",
  labelSearchUser: "Search User",
  labelSearchDate: "Choose Call Date",
  mediaTypeCallWAP: "Whatsapp Call",
  headerNameAndPhone: "Name & Contact Number",
  headerTicketId: "Ticket Id",
  headerCSAgent: "CS Agent,",
  headerChannel: "Channel",
  headerResolveTime: "Resolve Time",
  headerClosedBy: "Closed By",
  headerAction: "Action",
  historyRequestType: "History Type",
  historyCallType: "Call history",
  recordCallType: "Call record",
  validationDateRequiredMessage: "Date required",
  requestHistoryStatusDone: "Done",
  requestHistoryStatusInProgress: "In progress",
  requestHistoryStatusFailed: "Failed",
  tooltipDownloadReport: "Download history",
  tooltipCannotDownloadReport: "Export report currently being processed",
  headerReportFilename: "File Name",
  headerReportUser: "User",
  headerReportType: "History Type",
  headerReportCreatedAt: "Create Date",
  headerReportStatus: "Status",
  errorOpeningRecord: "Something wrong opening record data",
  errorAnswerCall: "Something wrong answering call",
  callButtonMuteDisabled: "Your call is on hold, you can not unmute microphone",
  errorHoldCall: "An error occurred when holding the call",
  ringingStatusDuration: "Queued for {0}",
  answeredStatusDuration: "In call for {0}",
  inboundCallCloseRoomSuccess: "Call room closed successfully",
  closeCallRoomTitle: "Close Call",
  closeCallRoomNote: "Call room will be moved to Call History",
  chatroomChatDetailCallStarted: "Call started",
  chatroomChatDetailRoomId: "Room ID",
  inboundCallUpdateRoomSuccess: "Call room updated successfully",
  inboundCallUpdateRoomFailed: "Call room update failed",
  inboundCallChatFailed: "Failed to send message",
  inboundCallActivateMic: "Microphone is not allowed",
  inboundCallActivateMicSubtitle:
    "Enable microphone permission to receive calls",
  inboundCallActivateMicDialogTitle: "Allow Microphone",
  inboundCallActivateMicDialogContent:
    "To answer calls, make sure Microphone permission is already given. Click the {0} icon next to the Kokatto URL, then click the enable button on the Microphone option.",
  inboundCallMicPermissionErrorMessage:
    "Turn on {0} in the site settings first.",
  inboundCallMicPermission: "microphone permission",
  inboundCallListEmptyState: "No active calls",
  inboundCallActiveCallLimitationError:
    "You can only have 1 active call at a time.",
  inboundCallPickupByAnotherAgent: "Call is already answered by another agent.",
  roomTypeWhatsapp: "Whatsapp Call",
  roomTypePhone: "Call Center",
  roomTypeAll: "All",
  retryButton: "Retry",
  callButtonTransfer: "Transfer",
  successTransferCall: "Call transferred successfully",
  errorTransferCall: "Failed to transfer call",
  callDetail: "Call Detail",
  inboundCallRoleNotAllowedAnswer: "You don’t have the role to answer call.",
  inboundCallRoleNotAllowedReject: "You don’t have the role to reject call.",
  menuCallPerformanceTabReport: "Call Center",
  callPerformanceReport: "Call Performance",
  callAnalyticsReport: "Analytics",
};

export default { id, en };
